import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { BooleanInput } from '@angular/cdk/coercion';
import { Subject, takeUntil } from 'rxjs';
import { User } from 'app/core/user/user.types';
import { UserService } from 'app/core/user/user.service';
import { SessionStorageService, SessionUser } from 'app/core/services/session-storage.service';

@Component({
    standalone: false,
    selector       : 'user',
    templateUrl    : './user.component.html',
    encapsulation  : ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs       : 'user'
})
export class UserComponent implements OnInit, OnDestroy
{
    /* eslint-disable @typescript-eslint/naming-convention */
    static ngAcceptInputType_showAvatar: BooleanInput;
    /* eslint-enable @typescript-eslint/naming-convention */

    @Input() showAvatar: boolean = true;
    user: User;
    user_ui: any;
    user_ui_role: any[];

    private _unsubscribeAll: Subject<any> = new Subject<any>();

    /**
     * Constructor
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _router: Router,
        private _userService: UserService,
        private sessionStorageService: SessionStorageService
    )
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    async ngOnInit(): Promise<void>
    {
        // Subscribe to user changes
        await this._userService.user$
            .then((user: any) => {
                this.user = user;
                this.user.status = 'online';
                this.user_ui_role = user.roles;
                this.user.avatar = user.avatarUrl;

                // Store user data in session storage
                const sessionUser: SessionUser = {
                    id: this.user.id,
                    email: user.email,
                    firstName: user.firstName,
                    lastName: user.lastName,
                    mobile: user.mobile,
                    avatarUrl: user.avatarUrl,
                    roles: user.roles
                };
                this.sessionStorageService.setUser(sessionUser);

                // Mark for check
                this._changeDetectorRef.markForCheck();
            });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Update the user status
     *
     * @param status
     */
    updateUserStatus(status: string): void
    {
        // Return if user is not available
        if ( !this.user )
        {
            return;
        }

        // Update the user
        this._userService.update({
            ...this.user,
            status
        }).subscribe();
    }

    /**
     * User Roles 
     */
    public getRolesString(): string {
        if (this.user && Array.isArray(this.user_ui_role) && this.user_ui_role.length > 0) {
          return this.user_ui_role.map(role => role.level).join(', ');
        }
        return '';
      }

     /**
     * Profile
     */
        profile(): void
        {
            this._router.navigate(['/profile']);
        }

     /**
     * Settings
     */
             settings(): void
             {
                 this._router.navigate(['/settings']);
             }

    /**
     * Sign out
     */
    signOut(): void
    {
        this._router.navigate(['/sign-out']);
    }
}
